module.exports = "<header class=\"header flex-box flex-just-space-between flex-align-center\">\n    <button class=\"back-to-button\" [disabled]=\"disableButtons\" (click)=\"goBackAction()\">< Back to Quote & Invoice Templates</button>\n    <button class=\"btn btn-lg btn-info mb-0\" [disabled]=\"disableButtons\" spinning-wheel [is-spinning-wheel-active]=\"disableButtons\" (click)=\"saveAction()\">Save Template</button>\n</header>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/common/template-edit-header/template-edit-header.component.html
// module id = ./web/modern/components/settings/common/template-edit-header/template-edit-header.component.html
// module chunks = 0